import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import { register } from "@teamhanko/hanko-elements";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const hankoOptions = {
    storageKey: config.public.hanko.cookieName
  };
  nuxtApp.hook("app:mounted", async () => {
    await register(config.public.hanko.apiURL, hankoOptions);
  });
});
